import { useState, useEffect } from 'react';
import _ from 'lodash';
import CommonConstants from 'sg-common-constants';
import { SgAdobeTargetOfferService } from '../../sg-adobe-target';

function useSgBrowserNavigation({
    currentStep,
    basePath,
    steps,
    location,
    history,
    jumpTo
}) {
    const [changingWizardStep, setChangingWizardStep] = useState(false);
    const locationPath = location.pathname.substring(location.pathname.lastIndexOf('/'));
    const locationIndex = _.findIndex(steps, { path: locationPath });

    const hasLocationChangedTo = (stepIndex) => {
        return steps[stepIndex] && location.pathname === `${basePath}${steps[stepIndex].path}`
            && history.action === 'POP';
    };

    const hasLocationChangedToPrevious = (stepIndex) => {
        return steps[locationIndex] && locationIndex < stepIndex
            && history.action === 'POP';
    };

    const getEligibleStepIndex = (currIndex) => {
        const availableSteps = _.slice(steps, 0, currIndex);
        return _.findLastIndex(availableSteps, (el) => el.stepProps.skipInWizard !== true);
    };
    const getAdobeOffers = () => {
        SgAdobeTargetOfferService.locationChanged();
    };

    useEffect(() => {
        setChangingWizardStep(true);
    }, [currentStep]);

    useEffect(() => {
        if (changingWizardStep) {
            setChangingWizardStep(false);
        }
    }, [changingWizardStep]);

    useEffect(() => {
        getAdobeOffers();
        const currIndex = steps.findIndex((el) => el.path === currentStep.path);
        if (hasLocationChangedToPrevious(currIndex)) {
            jumpTo(getEligibleStepIndex(currIndex));
        }
        if (hasLocationChangedTo(locationIndex)) {
            setChangingWizardStep(true);
        }
        if (locationIndex === -1 && history.action === 'POP') {
            if (location.pathname === '/journey') {
                history.goBack();
            } else {
                const err = { appErrorCode: CommonConstants.SG_ERROR_CODES.SAGA_WRONG_URL_ERROR };
                throw err;
            }
        }
    }, [location, locationIndex]);

    const expectedPath = `${basePath}${currentStep.path}`;

    if (!location.pathname.startsWith(expectedPath) && changingWizardStep) {
        const nextLocation = {
            pathname: expectedPath,
            state: location.state
        };
        return nextLocation;
    }

    return false;
}

export default useSgBrowserNavigation;
